var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{attrs:{"dark":"","app":"","clipped-left":"","color":"#1c344b"}},[_c('v-toolbar-title',{staticClass:"omni-title mt-1"},[_vm._v("OMNI USER PORTAL HELPDESK")]),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }